import Modal from "@root/shared/components/Modal";
import { type ComponentProps, type FC, Fragment } from "react";
import { HelpTextBox } from "@userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/HelpTextBox";
import { SearchForm } from "@userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/SearchForm";
import { SearchResultBox } from "@userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/SearchResultBox";
import { SearchInfoText } from "@root/userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/SearchInfoText";
import { PromptToSearchAgainInfo } from "@userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/PromptToSearchAgainInfo";
import {
  type SearchResult,
  type ClientSelectOptions,
} from "@userFrontend/features/clientReview/components/ClientReviewInputs/type";
import * as styles from "./styles.css";

type Props = {
  isShowSearchModal: boolean;
  handleCloseModal: () => void;
  searchResults?: SearchResult[];
  handleClientSelect: ClientSelectOptions;
  isShowClientsDetail: { clientId: number; isShowShopName: boolean }[];
  handleShowTextButton: (clientId: number) => void;
  tooManyResultErrorText?: string;
  noResultError: boolean;
  displaySearchText: boolean;
  isSearching: boolean;
  handleReturnToMyPageTop: () => void;
  userContactPath: string;
} & ComponentProps<typeof SearchForm>;

export const SearchModal: FC<Props> = ({
  isShowSearchModal,
  handleCloseModal,
  clientNameValue,
  shopNameValue,
  clientNameErrorText,
  shopNameErrorText,
  handleClientSearch,
  handleChangeClientNameValue,
  handleChangeShopNameValue,
  searchResults,
  handleClientSelect,
  isShowClientsDetail,
  handleShowTextButton,
  tooManyResultErrorText,
  noResultError,
  displaySearchText,
  isSearching,
  handleReturnToMyPageTop,
  userContactPath,
}) => {
  return (
    <Modal
      isShow={isShowSearchModal}
      spAppearanceType="bottom"
      headerTitle="投稿先の選択"
      onClose={handleCloseModal}
    >
      <>
        <div className={styles.title}>投稿先企業の検索</div>
        <SearchForm
          clientNameValue={clientNameValue}
          shopNameValue={shopNameValue}
          clientNameErrorText={clientNameErrorText}
          shopNameErrorText={shopNameErrorText}
          handleClientSearch={handleClientSearch}
          handleChangeClientNameValue={handleChangeClientNameValue}
          handleChangeShopNameValue={handleChangeShopNameValue}
        />
        <div className={styles.searchTitle}>検索結果</div>
        {(tooManyResultErrorText || noResultError) && (
          <PromptToSearchAgainInfo
            tooManyResultErrorText={tooManyResultErrorText}
            noResultError={noResultError}
          />
        )}
        {searchResults && (
          <>
            {searchResults.map((searchResult, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={`${searchResult.clientName}-${index}`}>
                <SearchResultBox
                  clientName={searchResult.clientName}
                  clientShops={searchResult.clientShops}
                  onClickSelect={(shop) =>
                    handleClientSelect({
                      selectedSiteId: searchResult.siteId,
                      clientName: searchResult.clientName,
                      params: {
                        clientId: searchResult.clientId,
                        clientShopId: shop.shopId,
                      },
                      clientShopName: shop.shopName,
                    })
                  }
                  showAllShops={
                    isShowClientsDetail.filter(
                      ({ clientId }) => clientId === searchResult.clientId,
                    )?.[0]?.isShowShopName
                  }
                  onClickShowTextButton={() => handleShowTextButton(searchResult.clientId)}
                  onClickNoShopPost={() =>
                    handleClientSelect({
                      selectedSiteId: searchResult.siteId,
                      clientName: searchResult.clientName,
                      params: {
                        clientId: searchResult.clientId,
                      },
                    })
                  }
                />
              </Fragment>
            ))}
          </>
        )}
        <SearchInfoText displaySearchText={displaySearchText} isSearching={isSearching} />
        <div className={styles.helpTextBoxWrapper}>
          <HelpTextBox handleOnClick={handleReturnToMyPageTop} href={userContactPath} />
        </div>
      </>
    </Modal>
  );
};
